import { sylvanus } from '~/services/serviceInstances';

import { GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiResponse } from '../../types/sylvanus/platformAdmin';

type Response =
  GetModelSummaryForClientApiV1ModelsClientClientIdSummaryGetApiResponse;
interface Request {
  clientId: string;
}

// This API is used for SuperAdmin to get the model summary for a specific client
export const getModelsQuotaSummary = async ({
  clientId,
}: Request): Promise<Response> => {
  const response: Response = await sylvanus.get(
    `/models/client/${clientId}/summary`,
  );
  return response;
};
